module.exports = {
	"ha": "iha",
	"id": 5.3,
	"report": {
		"ha": "Interior Health",
		"group": "HSDA",
		"period": "2017 Q2–2018 Q1",
		"lastYear": "2018",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 720,
			"height": 500,
			"marginTop": 60,
			"marginLeft": 90,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 80px;\">Figure 5.3</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Interior Health by Age Category, Year Ending 2018 Q1 <sup style=\"font-size: 10px;\">8</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -130,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 87.09677419354838,
						"dataLabels": {
							"enabled": true,
							"format": "27",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 74.19354838709677,
						"dataLabels": {
							"enabled": true,
							"format": "23",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 67.74193548387096,
						"dataLabels": {
							"enabled": true,
							"format": "21",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 64.51612903225806,
						"dataLabels": {
							"enabled": true,
							"format": "20",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 51.61290322580645,
						"dataLabels": {
							"enabled": true,
							"format": "16",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 95.65217391304348,
						"dataLabels": {
							"enabled": true,
							"format": "66",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 78.26086956521739,
						"dataLabels": {
							"enabled": true,
							"format": "54",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 72.46376811594203,
						"dataLabels": {
							"enabled": true,
							"format": "50",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 65.21739130434783,
						"dataLabels": {
							"enabled": true,
							"format": "45",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 49.275362318840585,
						"dataLabels": {
							"enabled": true,
							"format": "34",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 99.23664122137404,
						"dataLabels": {
							"enabled": true,
							"format": "130",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 74.80916030534351,
						"dataLabels": {
							"enabled": true,
							"format": "98",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 67.93893129770993,
						"dataLabels": {
							"enabled": true,
							"format": "89",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 64.8854961832061,
						"dataLabels": {
							"enabled": true,
							"format": "85",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 45.80152671755725,
						"dataLabels": {
							"enabled": true,
							"format": "60",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 98.54014598540147,
						"dataLabels": {
							"enabled": true,
							"format": "405",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 82.7250608272506,
						"dataLabels": {
							"enabled": true,
							"format": "340",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 78.83211678832117,
						"dataLabels": {
							"enabled": true,
							"format": "324",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 74.93917274939173,
						"dataLabels": {
							"enabled": true,
							"format": "308",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 56.20437956204379,
						"dataLabels": {
							"enabled": true,
							"format": "231",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -12.903225806451612,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -14.814814814814813,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -8.695652173913048,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -4.761904761904767,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -19.999999999999996,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -4.347826086956519,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -18.181818181818176,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -7.4074074074074066,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -9.999999999999998,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -24.444444444444446,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -0.7633587786259555,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -24.615384615384617,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -9.183673469387754,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -4.49438202247191,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -29.411764705882348,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -1.4598540145985384,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -16.049382716049386,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -4.705882352941182,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -4.938271604938271,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -25,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "< 30<br>n=31"
			},
			{
				"x": 9,
				"text": "30–39<br>n=69"
			},
			{
				"x": 15,
				"text": "40–49<br>n=131"
			},
			{
				"x": 21,
				"text": "≥ 50<br>n=411"
			}
		],
		"dataTable": {
			"< 30": [
				31,
				27,
				23,
				21,
				20,
				16
			],
			"30–39": [
				69,
				66,
				54,
				50,
				45,
				34
			],
			"40–49": [
				131,
				130,
				98,
				89,
				85,
				60
			],
			"≥ 50": [
				411,
				405,
				340,
				324,
				308,
				231
			]
		}
	},
	"callback": "C:\\Users\\Rafael\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_iha_5_3.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_iha_5_3.json
// module id = 232
// module chunks = 0